/**
 * Child is placed at the center of parent.
 * Child size and aspect ratio is preserved.
 * @param {object} parent
 * @param {object} child
 * @returns {object}
 */
const none = (parent, child) => {
  const { width: childWidth, height: childHeight } = child;
  return {
    width: childWidth,
    height: childHeight,
    x: (parent.width - childWidth) / 2,
    y: (parent.height - childHeight) / 2,
  };
};

export default none;
